<template>
    <navbar>
        <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
            &#9776;
        </button>
        <a class="navbar-brand text-center" href="/#/">
            <img src="/static/images/logo_inline.png" alt="Dowhile" width="140">
        </a>
        <ul class="nav navbar-nav d-md-down-none">
            <li class="nav-item">
                <a class="nav-link navbar-toggler sidebar-toggler" href="#" @click="sidebarMinimize">&#9776;</a>
            </li>
            <!--<li class="nav-item px-3">-->
            <!---->
            <!--</li>-->
            <!-- <li class="nav-item px-3">
                <a class="nav-link" href="#">Clientes</a>
            </li> -->
        </ul>

        <div class="dropdown" style="cursor: pointer">
            <a class="dropdown-toggle" role="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
               aria-expanded="false">
                    <span class="d-md-down-none">
                      {{ (user.empresa != null ? user.empresa.nomeFantasia + ' - ' : '') }} {{ user.nome }}
                    </span>
            </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                <!-- <a class="dropdown-item" @click="changeCompany" v-if="isUsuarioRepresentante()"><i class="icon-briefcase"></i> Trocar Empresa</a> -->
                <a class="dropdown-item" @click="changePassword"><i class="fa fa-key"></i> Alterar senha</a>
                <a class="dropdown-item" @click="logout"><i class="fa fa-lock"></i> Sair</a>
            </div>
        </div>

        <ul class="nav navbar-nav ml-auto">
            <li class="nav-item d-md-down-none">
                <a class="nav-link navbar-toggler aside-menu-toggler" href="#" @click="asideToggle">&#9776;</a>
            </li>
        </ul>
    </navbar>
</template>
<script>
    import navbar from './Navbar'
    import Facade from '@/facade/facade';

    const facade = new Facade();

    export default {
        name: 'header',
        components: {
            navbar,
        },
        data() {
            return {
                user: {},
                empresaAtiva: {}
            }
        },
        methods: {
            logout() {
                facade.logout()
                this.$router.push({name: 'Login'})
            },
            changePassword() {
                this.$router.push({name: 'change-password'})
            },
            changeCompany() {
                this.$router.push({name: 'SelectCompany'})
            },
            sidebarToggle(e) {
                e.preventDefault()
                document.body.classList.toggle('sidebar-hidden')
            },
            sidebarMinimize(e) {
                e.preventDefault()
                document.body.classList.toggle('sidebar-minimized')
            },
            mobileSidebarToggle(e) {
                e.preventDefault()
                document.body.classList.toggle('sidebar-mobile-show')
            },
            asideToggle(e) {
                e.preventDefault()
                document.body.classList.toggle('aside-menu-hidden')
            },
            isUsuarioRepresentante() {
                return facade.getAuthUser().tipo == 2
            }
        },
        created() {
            this.user = facade.getAuthUser();
            // Facade.getUserDefaultCompany().then(res => this.empresaAtiva = res.data)
        }
    }
</script>



// WEBPACK FOOTER //
// Header.vue?1550c97a